import { ApplicationRef, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CustomSnackbarService } from './custom-snackbar.service';
import { AuthService } from './auth.service';
import { LoginPromptService } from './login-prompt.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private customSnackbarService: CustomSnackbarService,
    private authService: AuthService,
    private loginPrompt: LoginPromptService,
    private appRef: ApplicationRef,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(err => {
        // A 401 here means the token is missing, expired, or was invalidated
        // server-side — whatever the caller was doing needs an active session,
        // so surface the login dialog directly instead of leaving the action
        // silently failed or just a passive toast.
        if (err.status === 401 && localStorage.getItem('token')) {
          this.authService.clearSession();
          this.customSnackbarService.open('Your session has ended. Please log in again.', 'OK', 'blue-snackbar');
          this.loginPrompt.open();
        }
        return throwError(() => err);
      }),
      // HTTP completions in this app don't reliably trigger Angular's automatic
      // zone-driven change detection (a pre-existing environment quirk — several
      // components already work around it locally with manual detectChanges()
      // calls). Forcing a tick centrally here means every HTTP-driven state
      // update actually renders, without every call site needing to remember to
      // do it itself.
      finalize(() => {
        // Deferred to a fresh macrotask: ticking synchronously right as the HTTP
        // observable completes can race Angular's own pending check-no-changes
        // pass in dev mode (NG0100) when a newly-rendered view's binding depends
        // on the state this response just changed. A macrotask runs after that
        // pass has fully settled.
        setTimeout(() => {
          try { this.appRef.tick(); } catch { /* a tick may already be in flight; the next one will catch up */ }
        });
      })
    );
  }
}
